/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

export const redactionKeys: string[] = [
	'password',
	'body.logonPassword',
];
